import React, {FC} from 'react';
import {Path, Svg} from 'react-native-svg';

export const FacebookIcon: FC = () => (
  <Svg width={24} height={24} fill="none">
    <Path
      fill="#1877F2"
      d="M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11c0 5.514-3.938 10.081-9.23 10.877h-.051V15.18h2.563l.487-3.18h-3.05V9.936c0-.87.427-1.718 1.793-1.718h1.387V5.51s-1.26-.215-2.463-.215c-2.512 0-4.155 1.523-4.155 4.28V12H7.488v3.18h2.793v7.686C5.023 22.041 1 17.491 1 12Z"
    />
  </Svg>
);
